//#region src/properties/roomPicker/mergePropertyIntoListing.ts
var e = (e, t) => ({
	...t,
	listing: {
		...t.listing,
		title: e.property.name
	},
	property: {
		...t.property,
		rating: e.property.rating,
		facilities: e.facilities ?? t.property.facilities ?? []
	},
	host: e.host ?? t.host,
	images: e.images,
	photos: e.photos,
	unit: {
		...t.unit,
		amenities: e.amenities,
		houseRules: e.house_rules,
		check_in_time: e.check_in_time,
		check_out_time: e.check_out_time
	},
	suspended: !1
});
//#endregion
export { e as mergePropertyIntoListing };
